"use strict";
import { jsx, jsxs } from 'react/jsx-runtime';
import { Stack, Text } from '@chakra-ui/react';

const DetailList = ({
  config,
  data,
  rowProps,
  labelProps,
  hideFalsyValues = false
}) => {
  return /* @__PURE__ */ jsx(Stack, { spacing: 1, children: config.map((item) => {
    const shouldItemRender = item.shouldRender ? item.shouldRender : () => true;
    if (hideFalsyValues && !data[item.key] || !shouldItemRender(data[item.key]))
      return null;
    return /* @__PURE__ */ jsxs(
      Stack,
      {
        alignItems: { base: "stretch", md: "center" },
        spacing: { base: 1, md: 5 },
        direction: { base: "column", md: "row" },
        ...rowProps,
        children: [
          /* @__PURE__ */ jsx(Text, { minWidth: "120px", fontWeight: "semibold", fontSize: "sm", ...labelProps, children: item.label }),
          item.renderItem ? item.renderItem(data[item.key]) : /* @__PURE__ */ jsx(Text, { children: data[item.key] })
        ]
      },
      item.key.toString()
    );
  }) });
};

export { DetailList as default };
